<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="rm-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="rm-analytics">

      <!-- Dashboard heading -->
      <v-layout row wrap align-end>
        <v-flex xs12 sm6>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm6>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
      </v-layout>

      <!-- Dashboard filters -->
      <v-layout row wrap>
        <v-flex xs12>
          <filters
            :dashboard-id="id"
            @apply-filters="fetchDashboardData"
            @clear-filters="fetchDashboardData">
          </filters>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
      <!--KPI-->
      <v-layout row wrap>
        <v-flex xs12 sm12 lg4>
          <widget-kpi
            widget-key="rm_kpiAppointment">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm12 lg4>
          <widget-kpi
            widget-key="rm_kpiAvgDurationMinutes">
          </widget-kpi>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 lg6>
          <chart-pie
            chart-key="rm_AppointmentAditionalService"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
        <v-flex xs12 sm12 lg6>
          <chart-pie
            chart-key="rm_AppointmentStoredTiers"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 lg6>
          <chart-bar
            chart-key="rm_AppointmentDayOfWeek"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 lg6>
          <chart-bar
            chart-key="rm_AppointmentHourOfDay"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 lg12>
          <chart-line-date
            chart-key="rm_AppointmentDateDay"
            @open-dialog="openDialog($event)">
          </chart-line-date>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 lg6>
          <chart-pie
            chart-key="rm_AdditionalServiceName"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
        <v-flex xs12 sm12 lg6>
          <chart-pie
            chart-key="rm_AdditionalServiceNumber"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <chart-bar
            chart-key="rm_AppointmentDurationMinutes"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12>
          <chart-bar
            chart-key="rm_AdvanceBookingDays"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
      </v-layout>
      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
// import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
// import am4themesMaterial from '@amcharts/amcharts4/themes/material'
import { am4themesRmTheme } from '@/themes'
// import moment from 'moment'

import BaseLoader from '@/components/loaders/BaseLoader'
import LastUpdateTime from '@/components/LastUpdateTime'
import Filters from './DashboardRmAppointmentsFilters'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartBar from '@/components/charts/ChartBar'
import ChartPie from '@/components/charts/ChartPie'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineDate from '@/components/charts/ChartLineDate'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ChartLineDateRender from '@/components/charts/ChartLineDateRender'
import ChartBarRender from '@/components/charts/ChartBarRender'
// import PdfExport from '@/components/pdfExport'

// am4core.useTheme(am4themesAnimated)
// am4core.useTheme(am4themesMaterial)
am4core.useTheme(am4themesRmTheme)
am4core.options.queue = true
export default {
  name: 'DashboardRmAppintments',
  components: {
    BaseLoader,
    LastUpdateTime,
    Filters,
    WidgetKpi,
    ChartBar,
    ChartPie,
    ChartLine,
    ChartLineRender,
    ChartLineDateRender,
    ChartLineDate,
    ChartBarRender
    // PdfExport
  },
  data () {
    return {
      id: 'rm',
      name: 'Appointments',
      charts: [
        {
          key: 'rm_kpiAppointment',
          title: 'chart.title.rm_kpiAppointment',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'rm_AppointmentAditionalService',
          title: 'chart.title.rm_AppointmentAditionalService',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: true,
            sortBy: null
          }
        },
        {
          key: 'rm_AppointmentStoredTiers',
          title: 'chart.title.rm_AppointmentStoredTiers',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: true,
            sortBy: null
          }
        },
        {
          key: 'rm_AppointmentDayOfWeek',
          title: 'chart.title.rm_AppointmentDayOfWeek',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 1000, // if no or less than 10, auto zoom will be enabled
            gridDistance: 25,
            barsWidth: 50, // in percentage, 50 default
            legend: false,
            labelRotation: 0,
            labelHorizontalCenter: 'middle', // options: 'top', 'bottom', 'middle'
            labelVerticalCenter: 'middle', // options: 'left', 'right', 'middle'
            textAlign: null,
            valueLabelTruncate: false // show elipsis if true on value labels on top
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: 'sort_column'
          }
        },
        {
          key: 'rm_AppointmentHourOfDay',
          title: 'chart.title.rm_AppointmentHourOfDay',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 50, // if no or less than 10, auto zoom will be enabled
            gridDistance: 25,
            barsWidth: 40, // in percentage, 50 default
            legend: false,
            labelRotation: 0,
            labelHorizontalCenter: 'middle', // options: 'top', 'bottom', 'middle'
            labelVerticalCenter: 'middle', // options: 'left', 'right', 'middle'
            textAlign: null,
            truncate: false, // show elipsis on axis values labels if true
            valueLabelTruncate: false // show elipsis if true on value labels on top
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'rm_AppointmentDateDay',
          title: 'chart.title.rm_AppointmentDateDay',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 10000
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null,
            rowsPerPage: 10000
          }
        },
        {
          key: 'rm_AdditionalServiceName',
          title: 'chart.title.rm_AdditionalServiceName',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: true,
            sortBy: null
          }
        },
        {
          key: 'rm_AdditionalServiceNumber',
          title: 'chart.title.rm_AdditionalServiceNumber',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: true,
            sortBy: null
          }
        },
        {
          key: 'rm_AdvanceBookingDays',
          title: 'chart.title.rm_AdvanceBookingDays',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 50, // if no or less than 10, auto zoom will be enabled
            gridDistance: 25,
            barsWidth: 40, // in percentage, 50 default
            legend: false,
            labelRotation: 0,
            labelHorizontalCenter: 'middle', // options: 'top', 'bottom', 'middle'
            labelVerticalCenter: 'middle', // options: 'left', 'right', 'middle'
            textAlign: null,
            truncate: false, // show elipsis on axis values labels if true
            valueLabelTruncate: false // show elipsis if true on value labels on top
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null,
            rowsPerPage: 10000
          }
        },
        {
          key: 'rm_AppointmentDurationMinutes',
          title: 'chart.title.rm_AppointmentDurationMinutes',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 50, // if no or less than 10, auto zoom will be enabled
            gridDistance: 25,
            barsWidth: 40, // in percentage, 50 default
            legend: false,
            labelRotation: 0,
            labelHorizontalCenter: 'middle', // options: 'top', 'bottom', 'middle'
            labelVerticalCenter: 'middle', // options: 'left', 'right', 'middle'
            textAlign: null,
            truncate: false, // show elipsis on axis values labels if true
            valueLabelTruncate: false // show elipsis if true on value labels on top
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null,
            rowsPerPage: 10000
          }
        },
        {
          key: 'rm_kpiAvgDurationMinutes',
          title: 'chart.title.rm_kpiAvgDurationMinutes',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'rm_additionalServicesSelected',
          title: 'chart.title.rm_additionalServicesSelected',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        }
      ],
      pdfExport: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFiltersGen', 'getCharts', 'getChartByKey', 'translation', 'currency'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.valueType && chart.valueType === 'money'
            ? chart.title = this.translation(chart.title, { currency: this.currency })
            : chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .rm-analytics {
  }
  @media only screen and (max-device-width: 700px) {
    .rm-analytics {
    }
  }
</style>
